import { getAchievementColors, getAchievementTier } from "../constants/AchievementColors";

interface AchievementBarProps {
    percentage: number;
    /** False keeps the bar neutral — see `getAchievementTier`. */
    isColored: boolean;
}

/**
 * How much of a test or exercise was reached. Purely decorative: every surface that shows it also
 * states the same figure in text beside it — visibly, or as screen-reader-only text where the
 * number is gated — so it is hidden from screen readers rather than announced twice.
 */
const AchievementBar = (props: AchievementBarProps) => {
    const colors = getAchievementColors(getAchievementTier(props.percentage, props.isColored));

    return (
        <div
            className={`flex h-s w-full overflow-hidden rounded-medium border bg-white ${colors.border}`}
            aria-hidden="true"
            data-testid="achievement-bar"
        >
            <div
                className={`h-full ${colors.barFill}`}
                style={{ width: `${props.percentage}%` }}
            />
        </div>
    );
};

export default AchievementBar;
